import admins from './admins'
import roles from './roles'
import common from './common'
import auth from './auth'
import importField from './import'
import emailconfig from './emailconfig'
import services from './services'
import branchconfig from './branchconfig'
import bookingview from './bookingview'
import temporaryrequest from './temporaryrequest'


export default {
  ...auth,
  ...admins,
  ...roles,
  ...common,
  ...importField,
  ...emailconfig,
  ...branchconfig,
  ...services,
  ...bookingview,
  ...temporaryrequest,
}
